(() => {
  const EVENT_PREFIX = 'vianatece:';

  function publish(eventName, eventData) {
    if (!window.Shopify || !Shopify.analytics || typeof Shopify.analytics.publish !== 'function') return;
    Shopify.analytics.publish(`${EVENT_PREFIX}${eventName}`, eventData);
  }

  function pageContext() {
    return {
      page_path: window.location.pathname,
      page_language: document.documentElement.lang || 'unknown'
    };
  }

  function trackSuccessfulLead() {
    const successMessage = document.querySelector('[data-vt-lead-success]');
    if (!successMessage) return;

    const navigation = performance.getEntriesByType('navigation')[0];
    if (navigation && navigation.type === 'reload') return;

    publish('generate_lead', {
      ...pageContext(),
      form_type: successMessage.dataset.vtLeadType || 'contact_form'
    });
  }

  function trackContactClick(event) {
    const link = event.target.closest('a[href]');
    if (!link) return;

    const rawHref = link.getAttribute('href') || '';
    let contactMethod = '';

    if (rawHref.startsWith('mailto:')) {
      contactMethod = 'email';
    } else if (rawHref.startsWith('tel:')) {
      contactMethod = 'phone';
    } else {
      let linkUrl;
      try {
        linkUrl = new URL(link.href, window.location.origin);
      } catch (_) {
        return;
      }

      if (linkUrl.origin === window.location.origin && /\/pages\/solicitar-acesso\/?$/.test(linkUrl.pathname)) {
        contactMethod = 'information_request';
      }
    }

    if (!contactMethod) return;

    publish('contact_click', {
      ...pageContext(),
      contact_method: contactMethod
    });
  }

  document.addEventListener('click', trackContactClick, { capture: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackSuccessfulLead, { once: true });
  } else {
    trackSuccessfulLead();
  }
})();
